import { NgModule } from '@angular/core';
import { PurchasesSearchDialogComponent } from './purchases-search-dialog.component';
import { CommonModule } from '@angular/common';
import { IntelliControlsModule } from '../../../../../core/_shared/intelli-controls/intelli-controls.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartialsModule } from '../../../../partials/partials.module';

@NgModule({
    declarations: [PurchasesSearchDialogComponent,
    ],
    imports: [
        CommonModule,
        IntelliControlsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatInputModule,
        IntelliControlsModule,
        PartialsModule,
        MatChipsModule,
        MatTableModule,
        MatPaginatorModule,
    ],
    exports: [PurchasesSearchDialogComponent]
})
  export class PurchasesSearchDialogModule { }